import React, { createContext, useContext } from 'react';
import { useMachineDashboardState, MachineDashboardContextValue } from './useMachineDashboard';

export type { MachineDashboardContextValue };

const MachineDashboardContext = createContext<MachineDashboardContextValue | null>(null);

export const MachineDashboardProvider = ({ children }: React.PropsWithChildren): React.JSX.Element => {
  const value = useMachineDashboardState();

  return <MachineDashboardContext.Provider value={value}>{children}</MachineDashboardContext.Provider>;
};

export const useMachineDashboardContext = (): MachineDashboardContextValue => {
  const context = useContext(MachineDashboardContext);

  if (!context) {
    throw new Error('useMachineDashboard must be used within MachineDashboardProvider');
  }

  return context;
};

export const useMachineDashboard = (): MachineDashboardContextValue => useMachineDashboardContext();
